import React from "react";
import { Col, Container, Row } from "reactstrap";

const MainLayout = ({ children }) => (
  <React.Fragment>
    <div className="d-table-cell align-middle">{children}</div>
  </React.Fragment>
);

export default MainLayout;
